import Image, { StaticImageData } from 'next/image';
import clsx from 'clsx';
import { SportsSubcategory } from '@/types/Game';

import {
  AmericanFootballIcon,
  BaseballIcon,
  BasketballIcon,
  FootballIcon,
  IceHockeyIcon,
  MMAIcon,
  TennisIcon,
} from '@/assets';

interface Props {
  selectedSport: SportsSubcategory | null;
  onChange: (subcategory: SportsSubcategory) => void;
}

const SPORTS_ICON_MAP: Record<SportsSubcategory, StaticImageData> = {
  'american football': AmericanFootballIcon,
  baseball: BaseballIcon,
  basketball: BasketballIcon,
  football: FootballIcon,
  'ice hockey': IceHockeyIcon,
  mma: MMAIcon,
  tennis: TennisIcon,
};

const GamesSportsFilter = ({ selectedSport, onChange }: Props) => {
  return (
    // <div className='flex flex-col gap-4 p-3 rounded-[64px] bg-black border border-secondary select-none'>
    <div className='flex flex-col gap-4 p-3 rounded-[64px] bg-[rgba(255,255,255,0.5)] select-none'>
      {(Object.entries(SPORTS_ICON_MAP) as [SportsSubcategory, StaticImageData][]).map(([sport, image]) => (
        <button
          type='button'
          key={sport}
          onClick={() => onChange(sport)}
          className={clsx(
            'relative transition hover:opacity-100 hover:scale-[1.2] w-10 h-10 sm:w-6 sm:h-6',
            selectedSport === sport ? 'opacity-100 scale-[1.2]' : 'opacity-60'
          )}>
          <div
            className={clsx(
              `rounded-full absolute w-[5px] h-[5px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition duration-[1350ms]`,
              selectedSport === sport ? 'shadow-[0_0_25px_20px_#81FDB7] sm:shadow-[0_0_25px_14px_#81FDB7]' : ''
            )}
          />
          <Image src={image} alt={sport} className='relative w-full h-full' />
        </button>
      ))}
    </div>
  );
};

export default GamesSportsFilter;
